// src/components/SubdomainRouter.js
// Detects if the app is accessed via a practitioner subdomain.
// If so, renders their public website directly, bypassing all app routing.
// Otherwise, renders the normal DF platform (children).
//
// Subdomain pattern: {slug}.divineframeworks.com
// Ignored subdomains: www, app, api, admin, mail, staging

import React, { useState, useEffect } from 'react';
import PublicWebsite from '../pages/PublicWebsite';

const IGNORED_SUBDOMAINS = ['www', 'app', 'api', 'admin', 'mail', 'staging'];

function getSubdomainSlug() {
  const hostname = window.location.hostname;

  // Local development — no subdomain detection, use /site/:slug route instead
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return null;
  }

  // Check if we're on a *.divineframeworks.com subdomain
  if (hostname.endsWith('.divineframeworks.com')) {
    const subdomain = hostname.replace('.divineframeworks.com', '');

    // Skip platform subdomains
    if (IGNORED_SUBDOMAINS.includes(subdomain)) {
      return null;
    }

    // This is a practitioner subdomain
    return subdomain;
  }

  // Not on divineframeworks.com (e.g. custom domain — future feature)
  return null;
}

export default function SubdomainRouter({ children }) {
  const [slug, setSlug] = useState(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const detectedSlug = getSubdomainSlug();
    setSlug(detectedSlug);
    setChecked(true);
  }, []);

  // Still checking — show nothing to prevent flash of wrong content
  if (!checked) return null;

  // Practitioner subdomain detected — render their public website
  if (slug) {
    return <PublicWebsite slug={slug} />;
  }

  // No subdomain — render the normal DF platform
  return children;
}
